// COPIED from ptc-core web/src/shell/FeedbackMenu.tsx @ de39fff (fleet feedback contract v1, 2026-10-21).
// Changes from the source: Tailwind utility classes → this app's CSS (`fb-*` in index.css; this app has
// no Tailwind), and the import paths. Behaviour unchanged. Conformance:
// src/feedback/FeedbackWidgetConformance.test.tsx.

// The header entry for the feedback loop (spec §3.1): one icon, two entries. Same hand-rolled
// popover idiom as NotificationBell / AnnouncementsBoard (button + positioned panel + outside-click
// and Escape dismiss), because Fluent popup surfaces are hostile to jsdom tests.

import { useEffect, useRef, useState } from 'react';
import { PersonFeedback20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import type { FeedbackKind } from '../../feedback/feedbackApi';
import { FeedbackDialog } from './FeedbackDialog';

export function FeedbackMenu() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [kind, setKind] = useState<FeedbackKind | null>(null);
  const rootRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    function onPointerDown(e: MouseEvent) {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) setOpen(false);
    }
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  function choose(k: FeedbackKind) {
    setOpen(false);
    setKind(k);
  }

  return (
    <div ref={rootRef} className="fb-menu">
      <button
        type="button"
        aria-label={t('shell.feedback.menuLabel')}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="fb-trigger"
      >
        <PersonFeedback20Regular />
      </button>
      {open && (
        <div role="menu" className="fb-panel">
          <button type="button" role="menuitem" className="fb-item"
            onClick={() => choose('problem')}>
            {t('shell.feedback.problemTitle')}
          </button>
          <button type="button" role="menuitem" className="fb-item"
            onClick={() => choose('improvement')}>
            {t('shell.feedback.improvementTitle')}
          </button>
        </div>
      )}
      <FeedbackDialog kind={kind} onClose={() => setKind(null)} />
    </div>
  );
}
